import { combineDucks } from "lib/utils/duck";

import BillingSettingsView from "./BillingSettingsView";
import CompanyMembersView from "./CompanyMembersView";
import CompanySettingsView from "./CompanySettingsView";
import EditCompanyMemberModal from "./EditCompanyMemberModal";
import EditPaymentProfileModal from "./EditPaymentProfileModal";
import MarketplaceSettingsView from "./MarketplaceSettingsView";
import PaymentsSettingsView from "./PaymentsSettingsView";
import ProductsSettingsView from "./ProductsSettingsView";
import SaasSettingsView from "./SaasSettingsView";
import UserAccountView from "./UserAccountView";
import WidgetsSettingsView from "./WidgetsSettingsView";

export default combineDucks({
  BillingSettingsView,
  CompanyMembersView,
  CompanySettingsView,
  EditCompanyMemberModal,
  EditPaymentProfileModal,
  MarketplaceSettingsView,
  PaymentsSettingsView,
  ProductsSettingsView,
  SaasSettingsView,
  UserAccountView,
  WidgetsSettingsView,
});



// WEBPACK FOOTER //
// ./src/modules/settings/index.js